<div class="container5">
  <div class="text_center mt-5">
    <p>
      <img [src]="'../../../../../../assets/img/' + bravo" alt="" />
    </p>
    <div class="bul">
      <h3>Votre bulletin d’adhésion a bien été signé électroniquement.</h3>
      <h3>Merci pour votre confiance !</h3>
    </div>
  </div>

  <div class="margin18 text_center margintop2">
    <p id="invRecup">
      Nous vous invitons à récupérer une copie de votre bulletin d’adhésion
      ci-dessous. Si des justificatifs vous sont demandés, merci de les
      transmettre à nos services (attestation de droits, carte d’identité, RIB)
      à l’adresse : souscriptionsante&#64;meilleurtaux.com
    </p>
  </div>

  <div class="margin10_35 c_theme" [ngClass]="c_theme">
    <div class="dowload parent-download">
      <div class="download-item">
        <button
          type="button"
          class="btnDownload"
          (click)="downloadSignatureBA()"
          [style.display]="loadingAdhesionDocumentSignature ? 'none' : ''"
        >
          Téléchargez votre bulletin d’adhésion
          <p>
            <img [src]="'../../../../../../assets/img/' + dowload" alt="" />
          </p>
        </button>
      </div>
      <div class="download-item">
        <button
          type="button"
          class="btnDownload"
          (click)="getDoc(tarif.produitTarif || '', docName.TG)"
        >
          Téléchargez le tableau des garanties
          <p>
            <img [src]="'../../../../../../assets/img/' + dowload" alt="" />
          </p>
        </button>
      </div>
      <div class="download-item">
        <button
          type="button"
          class="btnDownload"
          (click)="getDoc(tarif.produitTarif || '', docName.CG)"
        >
          Téléchargez la notice d’information
          <p>
            <img [src]="'../../../../../../assets/img/' + dowload" alt="" />
          </p>
        </button>
      </div>
      <div class="download-item">
        <button
          type="button"
          class="btnDownload"
          (click)="downloadLettreBienvenue()"
          [style.display]="loadingLettreBienvenue ? 'none' : ''"
        >
          Téléchargez la lettre de bienvenue
          <p>
            <img [src]="'../../../../../../assets/img/' + dowload" alt="" />
          </p>
        </button>
      </div>
    </div>
  </div>
  <div class="margin10_35 c_theme" [ngClass]="c_theme">
    <div class="background_white" id="nextstep">
      <h2>Prochaines étapes</h2>
      <div class="nextstepchildren">
        <div class="cirlcecolor">1</div>
        <div>
          Votre dossier de souscription signé électroniquement va être transmis
          automatiquement à notre service relation client.
        </div>
      </div>

      <div class="nextstepchildren">
        <div class="cirlcecolor">2</div>
        <div>
          Après vérification de votre bulletin d’adhésion, notre service
          relation client valide votre demande d’adhésion et vous aidera dans
          les démarches de résiliation de votre ancien contrat.
        </div>
      </div>

      <div class="nextstepchildren">
        <div class="cirlcecolor">3</div>
        <div>
          <p>Vous recevrez ensuite par courrier les documents contractuels :</p>
          <ul class="nextsteplist">
            <li>votre contrat</li>
            <li>les conditions particulières</li>
            <li>tableau de garanties</li>
            <li>
              la carte de tiers payants (10 jours avant la prise d’effet du
              contrat)
            </li>
          </ul>
        </div>
      </div>

      <div class="nextstepchildren">
        <div class="cirlcecolor">4</div>
        <div>
          Nous vous contacterons très prochainement pour faire un point sur
          cette souscription et répondre à toutes vos questions.
        </div>
      </div>
    </div>
  </div>

  <div class="margin10_35" id="contactFemme">
    <div id="contactFemmeBgr">
      <div id="contactFemmeGauche">
        <div class="marginLeft25">
          <div class="c_theme" [ngClass]="c_theme">
            <p class="needHelp">Besoin d’aide ?</p>
          </div>

          <b> Contactez-nous : </b>
          <p class="banNum">01 83 77 57 00</p>
          <p class="NoWrap">Du lundi au vendredi de 9h à 18h.</p>
        </div>
      </div>
      <div id="contactFemmeDroite">
        <p>
          Pour toute question concernant votre contrat, nos services sont à
          votre disposition. N'hésitez pas à nous contacter, nous vous
          répondrons dans les plus brefs délais.
          <!-- Si vous rencontrez la moindre difficulté, vous pouvez nous contacter à tout moment, un(e) conseiller(e) vous  accompagnera pour le déroulement de votre souscription en ligne -->
        </p>
      </div>
    </div>
  </div>
</div>
<!-- <script src="./js/script.js"></script>   -->
